export default "__VITE_ASSET__125363c9__"